// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-page {
  width: 82%;
  margin-left: 18%;
  overflow-y: auto;
  background: #eef1f6;
  color: #1f2937;
  font-family: "Segoe UI", Inter, Arial, sans-serif;
}
.support-page .wrap {
  display: flex;
  justify-content: center;
  padding: 48px 16px;
}
.support-page .card {
  width: 100%;
  max-width: 760px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
}
.support-page .card-title {
  margin: 0;
  padding: 28px 24px 22px;
  text-align: center;
  font-size: 28px;
  font-weight: 650;
  letter-spacing: -0.02em;
  color: #243044;
  border-bottom: 1px solid #e6e8ee;
}
.support-page .card-body {
  padding: 28px 36px 36px;
}
.support-page .section-title {
  margin: 0 0 28px;
  padding-bottom: 12px;
  border-bottom: 1px solid #d9dde6;
  font-size: 16px;
  font-weight: 650;
}
.support-page .grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px 28px;
}
.support-page .field {
  min-width: 0;
}
.support-page .span-2 {
  grid-column: 1/-1;
}
.support-page label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 650;
}
.support-page .req {
  color: #e11d48;
  margin-left: 2px;
}
.support-page input,
.support-page textarea {
  width: 100%;
  border: 1px solid #cfd5e1;
  border-radius: 4px;
  background: #fff;
  color: #111827;
  font: inherit;
  font-size: 14px;
  padding: 8px 10px;
}
.support-page input {
  height: 38px;
}
.support-page textarea {
  min-height: 118px;
  resize: vertical;
}
.support-page input:focus,
.support-page textarea:focus {
  outline: 2px solid rgba(32, 178, 132, 0.25);
  border-color: #20b284;
}
.support-page .hint {
  display: block;
  margin-top: 6px;
  color: #6b7280;
  font-size: 12px;
}
.support-page .error {
  display: block;
  min-height: 16px;
  margin-top: 4px;
  color: #e11d48;
  font-size: 12px;
}
.support-page .actions {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}
.support-page button {
  border: 0;
  border-radius: 999px;
  background: rgb(240, 134, 19);
  color: #fff;
  font: inherit;
  font-size: 15px;
  font-weight: 650;
  padding: 15px 30px;
  cursor: pointer;
}
.support-page button:hover {
  background: #18986f;
}
.support-page button:disabled {
  opacity: 0.7;
  cursor: wait;
}
.support-page .banner {
  margin-bottom: 18px;
  padding: 12px 14px;
  border-radius: 6px;
  font-size: 14px;
}
.support-page .banner.ok {
  background: #ecfdf5;
  color: #065f46;
}
.support-page .banner.bad {
  background: #fef2f2;
  color: #991b1b;
}
.support-page .hp {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
@media (max-width: 1024px) {
  .support-page {
    width: 72%;
    margin-left: 28%;
  }
}
@media (max-width: 700px) {
  .support-page .card-body {
    padding: 24px 18px 28px;
  }
  .support-page .grid {
    grid-template-columns: 1fr;
  }
  .support-page .card-title {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared-component/technicalSupport/style.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iDAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAEE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;AAAJ;AAGE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,gCAAA;AADJ;AAIE;EACE,uBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAME;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAQE;EACE,iBAAA;AANJ;AASE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AAUE;EACE,cAAA;EACA,gBAAA;AARJ;AAWE;;EAEE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AATJ;AAYE;EACE,YAAA;AAVJ;AAaE;EACE,iBAAA;EACA,gBAAA;AAXJ;AAcE;;EAEE,2CAAA;EACA,qBAAA;AAZJ;AAeE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAbJ;AAgBE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAdJ;AAiBE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAfJ;AAmBE;EACE,SAAA;EACA,oBAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,mBAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,YAAA;AAnBJ;AAsBE;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AApBJ;AAuBE;EACE,mBAAA;EACA,cAAA;AArBJ;AAwBE;EACE,mBAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAvBJ;AA0BE;EAtKF;IAuKI,UAAA;IACA,gBAAA;EAvBF;AACF;AAyBE;EAEE;IACE,uBAAA;EAxBJ;EA2BE;IACE,0BAAA;EAzBJ;EA4BE;IACE,eAAA;EA1BJ;AACF","sourcesContent":[".support-page {\n  width: 82%;\n  margin-left: 18%;\n  overflow-y: auto;\n  background: #eef1f6;\n  color: #1f2937;\n  font-family: \"Segoe UI\", Inter, Arial, sans-serif;\n\n  .wrap {\n    display: flex;\n    justify-content: center;\n    padding: 48px 16px;\n  }\n\n  .card {\n    width: 100%;\n    max-width: 760px;\n    background: #fff;\n    border-radius: 6px;\n    box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);\n  }\n\n  .card-title {\n    margin: 0;\n    padding: 28px 24px 22px;\n    text-align: center;\n    font-size: 28px;\n    font-weight: 650;\n    letter-spacing: -0.02em;\n    color: #243044;\n    border-bottom: 1px solid #e6e8ee;\n  }\n\n  .card-body {\n    padding: 28px 36px 36px;\n  }\n\n  .section-title {\n    margin: 0 0 28px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #d9dde6;\n    font-size: 16px;\n    font-weight: 650;\n  }\n\n  .grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 22px 28px;\n  }\n\n  .field {\n    min-width: 0;\n  }\n\n  .span-2 {\n    grid-column: 1 / -1;\n  }\n\n  label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 650;\n  }\n\n  .req {\n    color: #e11d48;\n    margin-left: 2px;\n  }\n\n  input,\n  textarea {\n    width: 100%;\n    border: 1px solid #cfd5e1;\n    border-radius: 4px;\n    background: #fff;\n    color: #111827;\n    font: inherit;\n    font-size: 14px;\n    padding: 8px 10px;\n  }\n\n  input {\n    height: 38px;\n  }\n\n  textarea {\n    min-height: 118px;\n    resize: vertical;\n  }\n\n  input:focus,\n  textarea:focus {\n    outline: 2px solid rgba(32, 178, 132, 0.25);\n    border-color: #20b284;\n  }\n\n  .hint {\n    display: block;\n    margin-top: 6px;\n    color: #6b7280;\n    font-size: 12px;\n  }\n\n  .error {\n    display: block;\n    min-height: 16px;\n    margin-top: 4px;\n    color: #e11d48;\n    font-size: 12px;\n  }\n\n  .actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 28px;\n  }\n  \n\n  button {\n    border: 0;\n    border-radius: 999px;\n    background: rgb(240, 134, 19);\n    color: #fff;\n    font: inherit;\n    font-size: 15px;\n    font-weight: 650;\n    padding: 15px 30px;\n    cursor: pointer;\n  }\n\n  button:hover {\n    background: #18986f;\n  }\n\n  button:disabled {\n    opacity: 0.7;\n    cursor: wait;\n  }\n\n  .banner {\n    margin-bottom: 18px;\n    padding: 12px 14px;\n    border-radius: 6px;\n    font-size: 14px;\n  }\n\n  .banner.ok {\n    background: #ecfdf5;\n    color: #065f46;\n  }\n\n  .banner.bad {\n    background: #fef2f2;\n    color: #991b1b;\n  }\n\n  .hp {\n    position: absolute;\n    left: -10000px;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n  }\n\n  @media (max-width: 1024px) {\n    width: 72%;\n    margin-left: 28%;\n  }\n\n  @media (max-width: 700px) {\n\n    .card-body {\n      padding: 24px 18px 28px;\n    }\n\n    .grid {\n      grid-template-columns: 1fr;\n    }\n\n    .card-title {\n      font-size: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
